<template>
  <div>
    <!-- 
      Form Validate Pre-Bet
    -->

    <v-card
      class="pa-1 mb-4 ma-2"
      elevation="0"
      outlined
      :color="$route.name == 'validatePreBet' ? 'colorDominant' : ''"
    >
      <div style="max-width: 600px; margin: 0 auto">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-card-text class="pb-0">
            <div class="pb-4 subtitle-1">{{ $t("digitPreBet") }}</div>
            <v-alert v-model="alert" type="warning" text outlined dismissible>{{
              alertMsg
            }}</v-alert>
            <v-text-field
              solo-inverted
              v-model="codBet"
              :rules="[codBetRules]"
              :label="$t('code')"
              clearable
              hide-details
              type="Number"
              autofocus
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              :loading="loading"
              type="submit"
              :disabled="!valid || loading"
              @click.prevent="getPreBet()"
              >{{ $t("next") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </div>
    </v-card>

    <!-- 
      Diaglog > BetCard
    -->
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="600px"
      :fullscreen="this.$vuetify.breakpoint.xsOnly"
      light
    >
      <v-card>
        <v-toolbar max-height="64" elevation="0" class="transparent">
          <v-toolbar-title>{{ title }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text style="height: auto" class="pa-2 grey darken-3">
          <!-- 
            Component BetCard 
          -->
          <BetCard />
        </v-card-text>
        <v-divider></v-divider>

        <!-- 
            Dialog Footer
          -->
        <div class="pa-4">
          <!-- Alert before confirme place bet -->
          <v-alert dense type="warning" v-show="showFooterAlert">
            {{ footerMsgAlert }}
          </v-alert>
          <!-- Alert before confirme place bet -->
          <v-alert dense type="info" v-show="sendNewBet">
            {{ $t("afterPerformingThe") }} <strong>{{ $t("new") }}</strong>
            {{ $t("betSendTheNewIDtoPunter") }}
          </v-alert>

          <div class="py-2 d-flex">
            <!-- Inserindo jogador da lista -->
            <v-combobox
              v-model="name_player"
              :loading="comboboxLoading"
              :placeholder="$t('nameAndLastName')"
              :items="fillCombobox"
              item-text="name"
              :label="$t('namePlayer')"
              dense
              class="elevation-0"
              hide-details
              outlined
              v-if="showCombobox"
            ></v-combobox>
            <!-- Adicionando Novo jogador -->
            <template v-else>
              <v-text-field
                :label="$t('addPunter')"
                :placeholder="$t('newPlayer')"
                dense
                class="elevation-0"
                hide-details
                outlined
                v-model="newPlayer"
              ></v-text-field>
            </template>

            <v-btn-toggle
              v-model="btnToggle"
              mandatory
              color="primary"
              dense
              class="ml-2"
            >
              <v-btn>
                <v-icon :value="0" text>
                  mdi-format-list-bulleted-square
                </v-icon>
              </v-btn>
              <v-btn :value="1" text>
                <v-icon> mdi-account-plus </v-icon>
              </v-btn>
            </v-btn-toggle>
          </div>

          <!-- Caso tenha alguma aposta inválida -->
          <template v-if="hasOddInvalid">
            <div
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'text-center my-2'
                  : 'text-left my-2'
              "
            >
              {{ $t("doYouWantToRemoveInvalidEvents") }}
              <br v-if="$vuetify.breakpoint.smAndDown" />
              <v-btn @click="closeDialog()" color="red" outlined class="ml-2">
                {{ $t("no") }}
              </v-btn>
              <v-btn
                @click="removeInvalidOdds()"
                color="green"
                class="white--text ml-4"
              >
                {{ $t("yes") }}
              </v-btn>
            </div>
          </template>
          <!-- Após remover as apostas inválidas onde será realizada uma nova aposta -->
          <template v-else-if="sendNewBet">
            <div
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'text-center my-2'
                  : 'text-left my-2'
              "
            >
              {{ $t("accomplish") }} <strong>{{ $t("new") }}</strong>
              {{ $t("textBet") }}?
              <br v-if="$vuetify.breakpoint.smAndDown" />
              <template class="mt-2">
                <v-btn @click="closeDialog()" color="red" outlined class="ml-2">
                  {{ $t("no") }}
                </v-btn>
                <v-btn
                  @click="placeBet()"
                  color="green"
                  class="white--text ml-4"
                  :loading="loading"
                  :disabled="loading"
                >
                  {{ $t("yes") }}
                </v-btn>
              </template>
            </div>
          </template>
          <!-- Cenário onde todas as odds são válidas, realizar a confirmação pré-aposta -->
          <div class="flex-wrap text-center" v-else>
            <div class="my-2">
              <v-btn class="mr-4" text @click="closeDialog()" outlined>{{
                $t("BtnCancel")
              }}</v-btn>

              <v-btn
                depressed
                color="success"
                :loading="loading2"
                @click="validateBet()"
                :disabled="
                  (!name_player && showCombobox) ||
                    (!showCombobox && !newPlayer)
                "
                >{{ $t("confirmPreBet") }}</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BetCard from "@/components/agent/Backoffice/bet/BetCard";
export default {
  name: "ViewAgentBetValidate",
  components: {
    BetCard,
  },
  data: () => ({
    valid: true,
    loading: false,
    loading2: false,
    comboboxLoading: false,
    name_player: "",
    codBet: "",
    fillCombobox: [],
    dialog: false,
    lazy: false,
    betData: "",
    alert: false,
    alertMsg: "",
    endpoint: "",
    title: "",
    //required: validate.required,
    showCombobox: true,
    btnToggle: 0,
    newPlayer: "",

    // Odd Valid
    hasOddInvalid: false,
    sendNewBet: false,
    // FooterAlert
    showFooterAlert: false,
    footerMsgAlert: "",

    agentPercentage: 0,
  }),

  computed: {
    retail() {
      return this.$store.state.operators.retail;
    },
    codBetRules() {
      return (v) => /^\d+$/.test(v) || this.$t("validCode");
    },
    // Bet
    bet() {
      return this.$store.state.betCard;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.reset();
      else {
        this.title = this.$t("validatePreBet");
      }
    },
    codBet(val) {
      if (!val) return;
      this.alert = false;
      this.alertMsg = "";
    },
    btnToggle(val) {
      this.showCombobox = val == 0 ? true : false;
    },
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      this.title = "";
    },

    reset() {
      this.$store.commit("setBetCard", "");
      this.name_player = "";
      this.hasOddInvalid = false;
      this.sendNewBet = false;
      this.showFooterAlert = false;
      this.footerMsgAlert = "";
    },
    // When had a invalid odds and the agent want to remove and make a new bet with valid odds
    placeBet() {
      this.loading = true;
      // Mounted a new bet from agent and removing invalid events
      let { amount, n_events, punter, events } = this.bet;

      const inputPunter = this.showCombobox
        ? this.name_player.name
        : this.newPlayer;
      punter = inputPunter ? inputPunter : punter;
      var enpoint =
        this.retail == 1
          ? "/agent/retail/bets/placeBet"
          : "/agent/bets/placeBet";
      let listOdds = [];

      // DEBUGG 403
      // events.forEach((event) => {
      //   event.odd_price = Number(event.odd_price) + 1;
      // });

      // Create a new atributes with valid events to place bet
      for (const [i, item] of events.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);
        for (let j = 0; j < val_odds.length; j++) {
          // Chaves que serão utilizadas para o enpoint
          // Monta com o número conforme existe o placebet
          const keys = ["id_odd", "odd_price"];
          if (keys.includes(key_odds[j]))
            listOdds[`${key_odds[j]}_${i + 1}`] = val_odds[j];
        }
      }

      const body = {
        n_events,
        punter,
        value_bet: amount,
        mobile: this.$vuetify.breakpoint.smAndDown ? 1 : 0,
        ...listOdds,
      };

      this.$axios
        .post(enpoint, this.$formdata(body))
        .then((resp) => {
          if (resp.status === 200) {
            if (this.retail == 1) {
              this.$store.commit("setCash", resp.data.credit_current);
            }

            this.reset();
            this.closeDialog();
            // Open FeedBack Dialog Success!
            this.$store.commit("setFeedback", {
              title: "ID:" + resp.data.id_bet,
              msg: resp.data.messages,
              type: "success",
              action: "printBet",
              id_bet: resp.data.id_bet,
              copy: false,
              whatsapp: true,
              shareBetPDF: this.$vuetify.breakpoint.smAndDown ? false : true,
              validated: true,
            });
            this.codBet = "";
          }
        })
        .catch((error) => {
          // Status 403 when has any odd and is necessary change or remove
          if (error.response.status == 403) {
            this.showFooterAlert = true;
            this.footerMsgAlert = error.response.data.messages.messages;
            const { dados, clear } = error.response.data.messages;
            // In case it is to remove the odd of the ticket
            if (clear) {
              this.removeOddCard(dados);
            }
            // If to update the ticket odd
            else {
              this.updateOdds(dados);
            }
          }
          if (error.response.status == 401) {
            this.$logout();
          }
        })
        .finally(() => (this.loading = false));
    },
    // When had odds to update values (Status 403)
    updateOdds(dados) {
      const updateIds = dados.map((item) => item);
      for (const id of updateIds) {
        this.betData.events.forEach((event) => {
          if (event.id_odd == id.id_odd) {
            event.odd_price = id.odd_price;
          }
          return event;
        });

        this.$store.commit("setBetCard", this.betData);
      }
      this.placeBet();
    },
    // When had odds to remove from card (Status 403)
    removeOddCard(dados) {
      const removedIds = dados.map((item) => item.id_odd);
      for (const id of removedIds) {
        const listValidOdds = this.betData.events.filter((event) => {
          return event.id_odd != id;
        });
        if (listValidOdds.length == 0) {
          this.alert = true;
          this.alertMsg = this.$t("thereAreNoValidEventsForThisTicket");
          this.closeDialog();
          return;
        }
        this.betData.events = listValidOdds;

        this.$store.commit("setBetCard", this.betData);
        this.placeBet();
      }
    },
    // Remove invalid odds from original PRE-BET
    removeInvalidOdds() {
      let data = this.bet;
      // Get Only Valid odds
      const listValidOdds = data.events.filter((event) => {
        return event.odds_valid != 0;
      });
      data.n_events = Number(listValidOdds.length);
      data.events = listValidOdds;
      // Punter Name
      const inputPunter = this.showCombobox
        ? this.name_player.name
        : this.newPlayer;
      data.punter = inputPunter ? inputPunter : data.punter;
      data.id = "-";
      this.$store.commit("setBetCard", data);
      this.hasOddInvalid = false;
      this.showFooterAlert = false;
      this.footerMsgAlert = "";
      this.sendNewBet = true;
      this.title = this.$t("placeNewBet");
    },

    // changeComboBox() {
    //   this.btnToggle = !this.btnToggle ? 0 : 1;
    //   this.showCombobox = !this.btnToggle ? false : true;
    // },

    // Validate Pre-Bet Flow
    // 1. getPreBet - Open Dialog to confirm pre-bet;
    getPreBet() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setFeedbackProgress", true);
        this.loading = true;
        let margin = this.$store.state.logged.data.margin_odds;
        const params = {
          id_bet: this.codBet,
          margin_odds: margin,
        };

        this.$axios
          .post("agent/bets/getPreBet", this.$formdata(params))
          .then((resp) => {
            if (resp.status === 200) {
              this.betData = resp.data.dados.apostas[0];
              // Verifica se tem odd invalida nos eventos
              // Altera o footer do do card
              this.hasOddInvalid = this.betData.events.some(
                (item) => item.odds_valid == "0"
              )
                ? true
                : false;
              if (this.hasOddInvalid) {
                this.showFooterAlert = true;
                this.footerMsgAlert = this.$t("checkInvalidBets");
              }

              this.name_player = this.betData.punter;
              this.dialog = true;
              this.listClientsAgents();
              this.$store.commit("setBetCard", this.betData);
              this.$store.commit("setBetAgent", resp.data.agent);
            }
          })
          .catch((err) => {
            if (err.response.data.status === 400) {
              // alert static
              this.alert = true;
              this.alertMsg = err.response.data.messages.error;
            }
          })
          .finally(() => (this.loading = false));
      }
    },

    // Validate Bet when doesn't have any problem, all events and odds are valid
    async validateBet() {
      this.$store.commit("setFeedbackProgress", true);
      this.loading2 = true;
      const bet = await this.buildBet(this.betData);

      this.endpoint =
        this.retail == 1
          ? "/agent/retail/bets/validateBet"
          : "/agent/bets/validateBet";
      this.$axios
        .post(this.endpoint, this.$formdata(bet))
        .then((resp) => {
          if (resp.status === 200) {
            if (this.retail == 1) {
              this.$store.commit("setCash", resp.data.credit_current);
            }

            this.insertClientsAgents();
            this.closeDialog();
            this.reset();
            // Open FeedBack Dialog Success!
            this.$store.commit("setFeedback", {
              title: this.$t("betCode") + this.codBet + this.$t("betPlaced"),
              msg: resp.data.messages,
              type: "success",
              action: "printBet",
              shareBetPDF: true,
              whatsapp: true,
              id_bet: resp.data.id_bet,
            });
            this.codBet = "";
            // reset form
            this.$refs.form.reset();
          }
        })
        .catch((error) => {
          // Status 403 when has any odd and is necessary change or remove
          if (error.response.status == 403) {
            this.showFooterAlert = true;
            this.footerMsgAlert = error.response.data.messages.messages;
            let { dados, clear } = error.response.data.messages;
            const oddsProblems = dados.map((item) => item.id_odd);
            if (clear) {
              for (const id of oddsProblems) {
                this.betData.events.forEach((event) => {
                  if (event.id_odd == id) {
                    event.odds_valid = "0";
                  }
                });
              }
              this.hasOddInvalid = true;
              this.name_player = this.betData.punter;
              this.$store.commit("setBetCard", this.betData);
            }
          }
        })
        .finally(() => (this.loading2 = false));
    },
    // Call list Client Agents inside betCard's combobox
    listClientsAgents() {
      this.comboboxLoading = true;
      this.$axios
        .get("/agent/clients/listClientsAgents")
        .then((response) => {
          if (response.status === 200) {
            this.fillCombobox = response.data.dados;
            this.newPlayer = "";
            this.btnToggle = 0;
            this.showCombobox = true;
          }
        })
        .catch((err) => {
          if (err.response.data.status === 400) {
            // alert static
            this.alert = true;
            this.alertMsg = err.response.data.messages.error;
          }
        })
        .finally(() => (this.comboboxLoading = false));
    },

    // Store Client name
    insertClientsAgents() {
      const body = {
        name_player:
          this.showCombobox == true ? this.name_player : this.newPlayer,
      };
      if (this.fillCombobox.some((item) => item.name == body.name_player))
        return;
      this.$axios
        .post("/agent/clients/insertClientsAgents", this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("setNotification", {
              msg: response.data.dados,
              color: "green",
            });
          }
        })
        .catch((err) => {
          this.nameOrPhoneAlert = true;
          this.nameOrPhoneAlertAlertMsg = err.response.data.messages.error;
        });
    },

    // Build Bet to validate
    buildBet(betData) {
      const bet = {
        id_bet: betData.id,
        n_events: betData.n_events,
        player_name:
          this.showCombobox == true ? this.name_player : this.newPlayer,
        mobile: this.$vuetify.breakpoint.mobile ? 1 : 0,
      };

      const odds = betData.events.map((item) => {
        const { id_odd, odd_price } = item;
        return {
          id_odd,
          odd_price,
        };
      });

      for (const [i, item] of odds.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);

        for (let j = 0; j < val_odds.length; j++) {
          bet[`${key_odds[j]}_${i + 1}`] = val_odds[j];
        }
      }

      if (typeof bet.player_name == "object") {
        bet.player_name = bet.player_name.name;
      }
      return bet;
    },
    // Odd rounding;
    RoundHalfDown(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
  },
};
</script>
